import { isValidElement } from 'react';

import cs from 'classnames';

import Button from 'components/shared/Button/Button';

const Footer = ({ footerActions, handleClose, className, isFooter = true }) => {
  const renderButton = (config, defaultText, defaultVariant, defaultOnClick) => {
    // If config is a React node, render it directly
    if (isValidElement(config)) {
      return config;
    }

    // If config is an object with custom JSX, render it
    if (config?.custom) return config.custom;

    // If config is an object with button props, render a Button
    if (config && typeof config === 'object') {
      return (
        <Button
          text={config.text || defaultText}
          onClick={config.onClick || defaultOnClick}
          variant={config.variant || defaultVariant}
          color={config.color}
          size={config.size || 'small'}
          isLoading={config.isLoading}
          isDisabled={config.isDisabled}
          {...config.buttonProps}
        />
      );
    }

    // If config is truthy but not an object/element, render default button
    if (config) {
      return (
        <Button text={defaultText} onClick={defaultOnClick} variant={defaultVariant} size="small" />
      );
    }

    return null;
  };

  const otherContent = footerActions?.other;
  const primaryButton = footerActions?.primary;
  const secondaryButton =
    footerActions?.secondary === undefined
      ? { text: 'Close', onClick: handleClose }
      : footerActions?.secondary;

  const hasContent = isFooter && (otherContent || primaryButton);

  if (!hasContent) return null;

  return (
    <div className={cs('Modal__footer h-[56px]', className)} data-dd-privacy="allow">
      <div className="flex w-full items-center justify-between gap-3">
        <div className="flex items-center">{otherContent}</div>
        <div className="ml-auto flex items-center gap-3">
          {renderButton(secondaryButton, 'Close', 'tertiary', handleClose)}
          {renderButton(primaryButton, 'Save', 'primary', undefined)}
        </div>
      </div>
    </div>
  );
};

export default Footer;
